export default {
  jp: {
    title: '利用規約',
    button: {
      accept: '閉じる'
    }
  },
  en: {
    title: 'Terms Of Use',
    button: {
      accept: 'CLOSE'
    }
  }

}
